export default __webpack_public_path__ + "4e713f8104f9afd08d9cb3cf37599aac.png";